export default function initM7() {
const $ = jQuery
$(window).on("load",function(){
   $(".enro-scroll-x").mCustomScrollbar({
      axis:"x",
      mouseWheel:'disable',
      advanced:{autoExpandHorizontalScroll:true},
      scrollButtons: { enable: true,scrollAmount: 410, scrollType: "stepped", },
      callbacks: {
         onTotalScroll: function() {
            //  loadMoreContent(); // Function to load more content
         },
         // onTotalScroll:function(){
         //    $(".enro-scroll-x").mCustomScrollbar("scrollTo", "left", {
         //       scrollInertia: 0 // Instant reset without animation
         //   });
         //  },
         // onTotalScrollOffset: 100 // Trigger load before hitting the end
     }
   });
});
}